import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { UtilService, TranslationService } from '../../../shared/index'; //app/shared/index barrel;
import { DialogResult } from '../../../shared/dialog/dialog-result.model';
import { RegistrationModificationOptions } from '../shared/crud/registration-modification-options.model';
import { RegistrationWizardModificationOptionsComponent } from '../wizard/modification-options/registration-wizard-modification-options.component';
import { RegistrationService } from '../shared/registration.service';

@Component({
  selector: 'wl-registration-delete',
  templateUrl: 'registration-delete.component.html',
    standalone: false
})
export class RegistrationDeleteComponent implements OnInit, AfterViewChecked {
  public _registrationService: RegistrationService;
  public _translationService: TranslationService;
  public _utilService: UtilService;

  @Input() public titleText: string = '';
  @Input() public headerText: string = '';
  @Input() public messageText: string = '';
  @Input() public yesText: string = '';
  @Input() public noText: string = '';
  @Input() public hasPaymentAmount: boolean = false;
  @Input() public hasRefundableCcPayment: boolean = false;

  public modificationOptions: RegistrationModificationOptions;

  @Output() onDialogResult = new EventEmitter<DialogResult>();
  @ViewChild('modificationOptionsComponent', { static: false })
  public modificationOptionsComponent: RegistrationWizardModificationOptionsComponent;

  public dialogResult: DialogResult;
  public selectedYes: boolean;
  public selectedNo: boolean;
  public isValid: boolean;
  public registrationId: number;
  public hasInvoice: boolean = false;
  public showModal = false;

  public constructor(translationService: TranslationService, utilService: UtilService, registrationService: RegistrationService) {
    this._translationService = translationService;
    this._utilService = utilService;
    this._registrationService = registrationService;

    this.dialogResult = DialogResult.NotSet;
    this.selectedYes = false;
    this.selectedNo = true;
    this.registrationId = 0;
  }

  public ngOnInit() {}
  public ngAfterViewChecked() {
    //check validation frequently
    this.isValid = !this.hasInvoice || this.modificationOptionsComponent.getValidationResult().isValid;
  }
  public showDialog = (
    registrationId: number,
    registrationInvoiceNumber: number,
    hasPaymentAmount: boolean,
    hasRefundableCcPayment: boolean
  ): void => {
    //reset options everytime called
    this.selectedNo = true;
    this.selectedYes = false;
    this.hasPaymentAmount = hasPaymentAmount;
    this.hasRefundableCcPayment = hasRefundableCcPayment;

    this.modificationOptionsComponent.registration.ModificationOptions = new RegistrationModificationOptions();
    //set this to true so the edit validation logic applys where we need adjustment types to be selected
    this.modificationOptionsComponent.registration.IsEdit = true;

    this.hasInvoice = registrationInvoiceNumber && registrationInvoiceNumber > 0;

    if (this._utilService.isNullEmptyOrWhitespace(this.titleText)) {
      this.titleText = this._translationService.getInstant('common.confirmation');
    }
    if (this._utilService.isNullEmptyOrWhitespace(this.yesText)) {
      this.yesText = this._translationService.getInstant('common.yes');
    }
    if (this._utilService.isNullEmptyOrWhitespace(this.noText)) {
      this.noText = this._translationService.getInstant('common.no');
    }
    if (this._utilService.isNullEmptyOrWhitespace(this.messageText)) {
      this.noText = this._translationService.getInstant('common.no');
    }

    this.showModal = true;
  };
  public closeDialog = (): void => {
    this.showModal = false;
  };

  public dialogYes = (): void => {
    this.modificationOptions = this.modificationOptionsComponent.registration.ModificationOptions;

    this.dialogResult = DialogResult.Yes;
    this.onDialogResult.emit(this.dialogResult);
    this.showModal = false;
  };
  public dialogNo = (): void => {
    this.dialogResult = DialogResult.No;
    this.onDialogResult.emit(this.dialogResult);
    this.showModal = false;
  };

  public yesChanged = ($event: any): void => {
    if (this.selectedYes == true) {
      this.selectedNo = false;
    } else {
      this.selectedNo = true;
    }
  };

  public noChanged = ($event: any): void => {
    if (this.selectedNo == true) {
      this.selectedYes = false;
    } else {
      this.selectedYes = true;
    }
  };
}
